import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { useResponsiveValue } from '../../hooks/use-match-media.js';
import { Box } from '../box/Box.js';

var GridItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "Grid__GridItem",
  componentId: "sc-r5l699-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 ", "px;\n  margin-bottom: ", "px;\n  width: ", "%;\n"], ["\n  padding: 0 ", "px;\n  margin-bottom: ", "px;\n  width: ", "%;\n"])), function (_a) {
  var gutter = _a.gutter;
  return gutter / 2;
}, function (_a) {
  var gutter = _a.gutter;
  return gutter !== undefined ? gutter : 30;
}, function (_a) {
  var columns = _a.columns;
  return 100 / columns;
});
var Grid = function (_a) {
  var columns = _a.columns,
    gutter = _a.gutter,
    childIsLarge = _a.childIsLarge,
    children = _a.children,
    rest = __rest(_a, ["columns", "gutter", "childIsLarge", "children"]);
  var columnValue = useResponsiveValue(columns);
  var gutterValue = useResponsiveValue(gutter);
  var isLargeValue = useResponsiveValue(childIsLarge);
  return React__default.createElement(Box, __assign({
    display: "flex",
    flexWrap: "wrap"
  }, rest), React__default.Children.map(children, function (child, i) {
    return child ? React__default.createElement(GridItem, {
      key: i,
      columns: columnValue,
      gutter: gutterValue
    }, React__default.cloneElement(child, {
      isLarge: isLargeValue
    })) : child;
  }));
};
Grid.defaultProps = {
  childIsLarge: false
};
var templateObject_1;

export { Grid };
//# sourceMappingURL=Grid.js.map
